import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../helpers";
import { OmitStrict } from "../utils";

export const StorybookPayload = z.object({
  id: z.string(),
  designSystemId: z.string(),
  sourceId: z.string(),
  payload: z.any(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type StorybookPayload = z.infer<typeof StorybookPayload>;
export type CreateStorybookPayload = DbCreateInputOmit<StorybookPayload>;
export type UpdateStorybookPayload = OmitStrict<DbUpdate<StorybookPayload>, "designSystemId" | "sourceId" | "id">;
